__webpack_require__.p = "/liveInventory/";